import(/* webpackMode: "eager" */ "/opt/trendrain/trendrain-web/src/app/store/page.tsx");
